import React from "react";
import styled from "styled-components";
import { Container, Store, Wrapper, wrap } from 'AppReact';
import { ThankYouSvg } from './thankYouSvg';
import { LogoEncircled } from 'molecules';
import { PropertyName } from './../../common/atoms';


const pageWrapper = Wrapper(styled.div`
    height: 100vh; display: 
    flex; justify-content: center; 
    align-items: center; 
    background: #F5F5F5;
`)


const ThankYouPage = Container({
    name: "Header",
    props: { property: Store, },
    elements: [
        {
            wrapper: Wrapper(styled.div`margin:0px 55px ;display: flex; flex-direction:column; justify-content: center; align-items: center;`),
            name: "Section",
            elements: [
                {
                    component: LogoEncircled,
                    name: 'Icon',
                    bindings: () => ({ icon: <ThankYouSvg /> }),
                },
                {
                    wrapper: Wrapper(styled.div`margin:40px 0; display: flex; flex-direction:column; justify-content: center; align-items: center;`),
                    name: "Description",
                    elements: [
                        {
                            component: PropertyName,
                            name: 'MainText',
                            displayValue: () => 'Thank You',

                        },
                        {
                            component: PropertyName,
                            name: 'SubText',
                            displayValue: () => 'For Applying!!',
                        },
                    ]
                },
            ]
        }
    ],
})


export default wrap(ThankYouPage, pageWrapper);
